/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WeeklyDriverShiftsRow,
    WeeklyDriverShiftsRowFromJSON,
    WeeklyDriverShiftsRowFromJSONTyped,
    WeeklyDriverShiftsRowToJSON,
} from './';

/**
 * driver毎週次乗務リスト
 * @export
 * @interface WeeklyDriverShiftsList
 */
export interface WeeklyDriverShiftsList {
    /**
     * 
     * @type {Array<WeeklyDriverShiftsRow>}
     * @memberof WeeklyDriverShiftsList
     */
    reports?: Array<WeeklyDriverShiftsRow>;
}

export function WeeklyDriverShiftsListFromJSON(json: any): WeeklyDriverShiftsList {
    return WeeklyDriverShiftsListFromJSONTyped(json, false);
}

export function WeeklyDriverShiftsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyDriverShiftsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reports': !exists(json, 'reports') ? undefined : ((json['reports'] as Array<any>).map(WeeklyDriverShiftsRowFromJSON)),
    };
}

export function WeeklyDriverShiftsListToJSON(value?: WeeklyDriverShiftsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reports': value.reports === undefined ? undefined : ((value.reports as Array<any>).map(WeeklyDriverShiftsRowToJSON)),
    };
}


